import React from "react";
import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useI18n } from "@/i18n/I18nProvider";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, languages, t } = useI18n();
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="language-switcher-btn"
          variant="ghost"
          size="sm"
          aria-label={t("cta.languageSwitcher")}
          className="h-9 px-2.5 text-slate-600 hover:text-[#6B46C1] hover:bg-slate-50 gap-1.5"
        >
          <Globe size={16} />
          <span className="text-base leading-none" aria-hidden>
            {current.flag}
          </span>
          {!compact && (
            <span className="text-sm font-medium uppercase tracking-wide">
              {current.code}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        data-testid="language-switcher-menu"
        align="end"
        className="w-52"
      >
        <DropdownMenuLabel className="text-xs uppercase tracking-[0.12em] text-slate-500">
          {t("cta.languageSwitcher")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className={`cursor-pointer flex items-center gap-2 ${
              l.code === lang ? "bg-[#6B46C1]/8 font-semibold" : ""
            }`}
          >
            <span className="text-lg leading-none" aria-hidden>
              {l.flag}
            </span>
            <span className="flex-1 text-sm">{l.nativeLabel}</span>
            {l.code === lang && (
              <Check size={14} className="text-[#6B46C1]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
